/**
 * Trusted partners list.
 * - Use `logo` for a local image (add file to src/images/partners/ and import here).
 * - Use `domain` to try Clearbit logo (logo.clearbit.com/domain). If both are set, `logo` is used first.
 * See TRUSTED-PARTNERS-GUIDE.md for step-by-step instructions.
 *
 * Example with local logo:
 *   import logoAcme from '../../images/partners/acme.png';
 *   { name: 'Acme Inc', domain: 'acme.com', logo: logoAcme },
 */

export const TRUSTED_PARTNERS = [
  { name: 'Bungalowny', domain: 'bungalowny.com' },
  { name: 'GupShup', domain: 'gupshup.io' },
  { name: 'Amminy', domain: 'amminy.com' },
  { name: 'Chotemiya', domain: 'chotemiya.com' },
  { name: 'Skewr', domain: 'skewr.com' },
  { name: 'Brewr', domain: 'brewrr.com' },
  { name: 'Elsie Rooftop', domain: 'elsierooftop.com' },
  { name: 'Horseshoe Kitchen', domain: 'horseshoekitchen.com' },
  { name: 'BrewShot', domain: 'brewshot.com' },
];

export const getLogoUrl = (domain) =>
  domain ? `https://logo.clearbit.com/${domain}` : null;
